import React from 'react';
import { Invoice, Transaction, CompanyInfo } from '../types';
import { X, Printer } from 'lucide-react';
import { printContent } from '../utils/print';
import { getCollectionNoticeHtml } from '../utils/printTemplates';

interface CollectionNoticeProps {
  invoice: Invoice;
  companyInfo: CompanyInfo | null;
  linkedExpenses?: Transaction[];
  onClose: () => void;
}

const CollectionNotice: React.FC<CollectionNoticeProps> = ({ invoice, companyInfo, linkedExpenses = [], onClose }) => {
  const isPaid = invoice.status === 'Paid';

  const handlePrint = () => {
    const html = getCollectionNoticeHtml(invoice, companyInfo, linkedExpenses, isPaid);
    printContent(isPaid ? `إيصال استلام - ${invoice.tenantName}` : `مطالبة مالية - ${invoice.tenantName}`, html);
  };

  return (
    <div 
      className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-fadeIn"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white w-full max-w-2xl shadow-2xl relative flex flex-col rounded-2xl overflow-hidden max-h-[90vh]">
        
        {/* Actions bar (UI only) */}
        <div className="p-4 bg-slate-50 border-b border-slate-200 flex justify-between items-center shrink-0 print:hidden">
          <button 
            onClick={handlePrint}
            className={`px-4 py-2 ${isPaid ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-fly-600 hover:bg-fly-700'} text-white rounded-lg font-bold flex items-center gap-2 transition-all active:scale-95 text-sm shadow-md`}
          >
            <Printer size={16} />
            <span>{isPaid ? 'طباعة الإيصال' : 'طباعة المطالبة'}</span>
          </button>
          <div className="font-bold text-slate-800 text-sm">{isPaid ? 'تفاصيل السداد والوصل' : 'تفاصيل المطالبة المالية'}</div>
          <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors active:scale-90">
             <X size={20} className="text-slate-400" />
          </button>
        </div>

        {/* Scrollable print area */}
        <div className="flex-1 overflow-y-auto p-6 sm:p-8 custom-scrollbar print:p-0 bg-slate-100/30 print:bg-white">
          <div 
            className="max-w-2xl mx-auto shadow-sm border border-slate-200 rounded-xl overflow-hidden print:border-0 print:shadow-none"
            dangerouslySetInnerHTML={{ __html: getCollectionNoticeHtml(invoice, companyInfo, linkedExpenses, isPaid) }}
          />
        </div>
      </div>
    </div>
  );
};

export default CollectionNotice;
